var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuvrirRideaux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.567 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 937",
    d: "M63.727 58.32H60.7V5.078A5.09 5.09 0 0 0 55.623 0H10.261a5.089 5.089 0 0 0-5.078 5.078V58.32H1.84a1.84 1.84 0 0 0 0 3.68h61.887a1.84 1.84 0 0 0 0-3.68m-6.7-29.208V58.32H34.783V3.673h20.841a1.406 1.406 0 0 1 1.4 1.4v24.039ZM31.358 32.2v26.12H9.12V5.078a1.4 1.4 0 0 1 1.4-1.4h20.84Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 938",
    d: "M10.669 52.123V5.781h19.57v8.34c0 13.988-13.365 10.95-15.16 18.371-1.178 4.872 2.088 17.961 1.6 19.225-.059.294-.351.294-.5.314a16.587 16.587 0 0 1-4.373.784c-.091 0 .189-.731.108-.7a3.308 3.308 0 0 1-1.078.137",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 939",
    d: "m15.042 32.186-4.781-2.309a.789.789 0 0 1-.372-1.069.826.826 0 0 1 1.091-.35l4.781 2.309a.79.79 0 0 1 .387 1.064.828.828 0 0 1-1.1.36l-.01-.005",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 940",
    d: "M55.385 52.247a3.3 3.3 0 0 1-1.078-.136c-.081-.027.2.705.107.705a16.543 16.543 0 0 1-4.372-.785c-.149-.02-.441-.019-.5-.314-.49-1.264 2.776-14.353 1.6-19.225-1.795-7.421-15.16-4.382-15.16-18.371v-8.34H55.55v46.342",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 941",
    d: "m51.177 32.186-.01.005a.828.828 0 0 1-1.1-.36.79.79 0 0 1 .387-1.064l4.781-2.309a.826.826 0 0 1 1.091.35.789.789 0 0 1-.372 1.069l-4.781 2.309",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuvrirRideaux);
export default __webpack_public_path__ + "static/media/ouvrir-rideaux.bcf26b4a1b4c657cea4bb4be54b5ce77.svg";
export { ForwardRef as ReactComponent };